package com.exura.features.legacyplans.api.dto

import kotlinx.serialization.Serializable
import kotlin.js.JsName

@Serializable
@JsName("IssueViaReceiverIdResult")
data class IssueViaReceiverIdResult(
    @JsName("issueId")
    val issueId: String
)

@Serializable
@JsName("HelloResult")
data class HelloResult(
    @JsName("message")
    val message: String,
)
